(function (w, d) {
  'use strict';

  var boot = d.getElementById('es-pdp-runtime');
  if (!boot || boot.getAttribute('data-es-booted') === '1') return;
  boot.setAttribute('data-es-booted', '1');

  function attr(name) {
    return boot.getAttribute(name) || '';
  }

  function removeNode(node) {
    try { if (node && node.parentNode) node.parentNode.removeChild(node); } catch (_err) {}
  }

  var config = {
    sizeGuideJs: attr('data-size-guide-js'),
    tryonCss: attr('data-tryon-css'),
    tryonJs: attr('data-tryon-js'),
    relatedCss: attr('data-related-css'),
    relatedJs: attr('data-related-js'),
    quickviewJs: attr('data-quickview-js'),
    quickviewLensJs: attr('data-quickview-lens-js'),
    lensbuilderCss: attr('data-lensbuilder-css'),
    lensbuilderJs: attr('data-lensbuilder-js'),
    fancyboxUmd: attr('data-fancybox-umd'),
    fancyboxBinder: attr('data-fancybox-binder'),
    stickySyncJs: attr('data-sticky-sync-js'),
    hasLensbuilder: attr('data-has-lensbuilder') === '1'
  };

  w.__ES_PDP_LAZY_ASSETS = {
    relatedCss: config.relatedCss,
    relatedJs: config.relatedJs,
    quickviewJs: config.quickviewJs,
    quickviewLensJs: config.quickviewLensJs,
    lensbuilderCss: config.lensbuilderCss,
    lensbuilderJs: config.lensbuilderJs,
    fancyboxUmd: config.fancyboxUmd,
    fancyboxBinder: config.fancyboxBinder,
    hasLensbuilder: config.hasLensbuilder
  };

  (function initSizeGuideIntentLoader() {
    var src = config.sizeGuideJs;
    if (!src) return;

    var promise = null;
    var ready = !!w.__ES_SIZE_GUIDE_BOOT__;
    var pending = null;

    function load() {
      if (ready) return Promise.resolve();
      if (promise) return promise;

      promise = new Promise(function (resolve, reject) {
        var existing = d.querySelector('script[data-es-size-guide-runtime]');
        if (existing && existing.getAttribute('data-es-load-failed') === '1') {
          removeNode(existing);
          existing = null;
        }
        if (existing) {
          if (w.__ES_SIZE_GUIDE_BOOT__ || existing.getAttribute('data-es-loaded') === '1') {
            ready = true;
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            existing.setAttribute('data-es-loaded', '1');
            ready = true;
            resolve();
          }, { once: true });
          existing.addEventListener('error', function () {
            existing.setAttribute('data-es-load-failed', '1');
            removeNode(existing);
            reject(new Error('Size Guide runtime failed to load'));
          }, { once: true });
          return;
        }

        var script = d.createElement('script');
        script.src = src;
        script.async = true;
        script.setAttribute('data-es-size-guide-runtime', 'es-size-guide.js');
        script.onload = function () {
          script.setAttribute('data-es-loaded', '1');
          ready = true;
          resolve();
        };
        script.onerror = function () {
          script.setAttribute('data-es-load-failed', '1');
          removeNode(script);
          reject(new Error('Size Guide runtime failed to load'));
        };
        (d.head || d.documentElement).appendChild(script);
      }).catch(function (error) {
        promise = null;
        ready = false;
        throw error;
      });
      return promise;
    }

    function findTrigger(target) {
      return target && target.closest ? target.closest('[data-es-size-guide-open]') : null;
    }

    function warm(event) {
      if (findTrigger(event.target)) load().catch(function () {});
    }

    function click(event) {
      var button = findTrigger(event.target);
      if (!button || ready) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pending = button;
      load().then(function () {
        var replay = pending;
        pending = null;
        if (replay && d.documentElement.contains(replay)) replay.click();
      }).catch(function () {
        pending = null;
      });
    }

    d.addEventListener('pointerover', warm, true);
    d.addEventListener('focusin', warm, true);
    d.addEventListener('touchstart', warm, { capture: true, passive: true });
    d.addEventListener('click', click, true);
  })();

  (function initTryonIntentLoader() {
    var cssSrc = config.tryonCss;
    var jsSrc = config.tryonJs;
    if (!cssSrc || !jsSrc) return;

    var promise = null;
    var ready = !!w.__ES_TRYON_CLEAN_LOADED__;
    var pending = null;

    function loadStyle() {
      return new Promise(function (resolve, reject) {
        var existing = d.querySelector('link[data-es-tryon-runtime-style]');
        if (existing && existing.getAttribute('data-es-load-failed') === '1') {
          removeNode(existing);
          existing = null;
        }
        if (existing) {
          if (existing.sheet || existing.getAttribute('data-es-loaded') === '1') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            existing.setAttribute('data-es-loaded', '1');
            resolve();
          }, { once: true });
          existing.addEventListener('error', function () {
            existing.setAttribute('data-es-load-failed', '1');
            removeNode(existing);
            reject(new Error('Virtual Try-On stylesheet failed to load'));
          }, { once: true });
          return;
        }

        var link = d.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssSrc;
        link.setAttribute('data-es-tryon-runtime-style', 'es-tryon-clean.css');
        link.onload = function () {
          link.setAttribute('data-es-loaded', '1');
          resolve();
        };
        link.onerror = function () {
          link.setAttribute('data-es-load-failed', '1');
          removeNode(link);
          reject(new Error('Virtual Try-On stylesheet failed to load'));
        };
        (d.head || d.documentElement).appendChild(link);
      });
    }

    function loadScript() {
      return new Promise(function (resolve, reject) {
        var existing = d.querySelector('script[data-es-tryon-runtime-script]');
        if (existing && existing.getAttribute('data-es-load-failed') === '1') {
          removeNode(existing);
          existing = null;
        }
        if (existing) {
          if (w.__ES_TRYON_CLEAN_LOADED__ || existing.getAttribute('data-es-loaded') === '1') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            existing.setAttribute('data-es-loaded', '1');
            resolve();
          }, { once: true });
          existing.addEventListener('error', function () {
            existing.setAttribute('data-es-load-failed', '1');
            removeNode(existing);
            reject(new Error('Virtual Try-On runtime failed to load'));
          }, { once: true });
          return;
        }

        var script = d.createElement('script');
        script.src = jsSrc;
        script.async = true;
        script.setAttribute('data-es-tryon-runtime-script', 'es-tryon-clean.js');
        script.onload = function () {
          script.setAttribute('data-es-loaded', '1');
          resolve();
        };
        script.onerror = function () {
          script.setAttribute('data-es-load-failed', '1');
          removeNode(script);
          reject(new Error('Virtual Try-On runtime failed to load'));
        };
        (d.head || d.documentElement).appendChild(script);
      });
    }

    function load() {
      if (ready) return Promise.resolve();
      if (promise) return promise;
      promise = Promise.all([loadStyle(), loadScript()]).then(function () {
        ready = true;
      }).catch(function (error) {
        promise = null;
        ready = false;
        throw error;
      });
      return promise;
    }

    function findTrigger(target) {
      return target && target.closest ? target.closest('[data-es-tryon-open]') : null;
    }

    function warm(event) {
      if (findTrigger(event.target)) load().catch(function () {});
    }

    function click(event) {
      var button = findTrigger(event.target);
      if (!button || ready) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pending = button;
      load().then(function () {
        var replay = pending;
        pending = null;
        if (replay && d.documentElement.contains(replay)) replay.click();
      }).catch(function () {
        pending = null;
      });
    }

    d.addEventListener('pointerover', warm, true);
    d.addEventListener('focusin', warm, true);
    d.addEventListener('touchstart', warm, { capture: true, passive: true });
    d.addEventListener('click', click, true);
  })();

  (function initStickySyncLoader() {
    var src = config.stickySyncJs;
    if (!src) return;

    var loading = false;
    var loaded = false;
    function load() {
      if (loaded || loading) return;
      var existing = d.querySelector('script[data-es-pdp-sticky-sync-asset]');
      if (existing && existing.getAttribute('data-es-load-failed') !== '1') {
        loaded = true;
        return;
      }
      if (existing) removeNode(existing);

      loading = true;
      var script = d.createElement('script');
      script.src = src;
      script.defer = true;
      script.setAttribute('data-es-pdp-sticky-sync-asset', 'es-pdp-sticky-sync.js');
      script.onload = function () {
        loading = false;
        loaded = true;
      };
      script.onerror = function () {
        loading = false;
        loaded = false;
        script.setAttribute('data-es-load-failed', '1');
        removeNode(script);
      };
      (d.head || d.documentElement).appendChild(script);
    }

    var media = w.matchMedia ? w.matchMedia('(min-width: 768px)') : null;
    if (!media || media.matches) load();
    if (media && media.addEventListener) media.addEventListener('change', function (event) {
      if (event.matches) load();
    });
    else if (media && media.addListener) media.addListener(function (event) {
      if (event.matches) load();
    });
  })();
})(window, document);
